import { EAnimalResidencyStatusDB, EAnimalResidencyStatusUI } from './residence.types';

export enum EFollowUpMedium {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export type TFollowUpItemDB = {
  id: string | null;
  author: {
    name: string;
    id: string;
  } | null;
  isEditable: boolean;
  animals:
    | {
        animalId: string;
        name: string;
        species: string | null;
        speciesPredefinedId?: string;
        residencyStatus: EAnimalResidencyStatusDB;
        isDeleted?: boolean;
        id: string;
      }[]
    | null;
  description: string;
  medium: EFollowUpMedium | null;
  occurredOn: string;
};

export type TFollowUpItemUI = {
  id: string | null;
  author: {
    name: string;
    id: string;
  } | null;
  isEditable: boolean;
  animals: {
    animalId: string;
    name: string;
    species: string | null;
    speciesPredefinedId?: string;
    residencyStatus: EAnimalResidencyStatusUI;
    isDeleted?: boolean;
    id: string;
  }[];
  description: string;
  medium: EFollowUpMedium | null;
  occurredOn: string;
};

export type TAddTenantFollowUpItemUI = {
  description: string;
  animalIds?: string[];
  tenantId: string;
};
export type TAddTenantFollowUpItemDB = {
  description: string;
  animalIds: string[] | null;
  tenantId: string;
};

export type TEditTenantFollowUpItemUI = {
  tenantId: string;
  tenantFollowUpItemId: string;
  initialAnimals: string[];
  finalAnimals: string[];
  description: string;
};
export type TEditTenantFollowUpItemDB = {
  tenantId: string;
  tenantFollowUpItemId: string;
  addedAnimals: string[] | null;
  removedAnimals: string[] | null;
  description: string;
};

export type TTenantAnimals = {
  animalId: string;
  animalName: string;
};
